import styled from "styled-components";

interface ITagsContentProps {
  knowLength: number;
}

interface IInputContainer {
  thereIsAnError?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 3px 7px 17px 0 rgba(55, 55, 55, 0.13);
  margin-top: 24px;
  z-index: 2;
  background-color: white;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: row;
    margin: 0 auto;
    margin-top: 28px;
    gap: 16px;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    flex-direction: row;
    margin-top: 24px;
    max-width: 70%;
    margin-left: 48px;
    gap: 16px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    max-width: 60%;
    margin-left: 48px;
  }
`;
export const SearchFor = styled.div`
  @media (max-width: 767px) {
    margin-top: 32px;

    max-width: 294px;
    width: 100%;
  }

  @media (min-width: 768px) {
    margin-top: 24px;

    max-width: 478px;
    width: 100%;
  }

  @media (min-width: 1441px) {
    margin-top: 9px;
    max-width: 478px;
    width: 100%;
  }
`;

export const TagsContent = styled.div<ITagsContentProps>`
  position: absolute;
  top: -18px;

  @media (max-width: 767px) {
    display: flex;
    overflow: auto;
    white-space: nowrap;
    width: 100%;
    > div {
      & + div {
        margin-left: 12px;
      }
    }
  }

  @media (min-width: 768px) {
    display: flex;

    max-width: 478px;

    margin: 0 auto;

    overflow: auto;
    white-space: nowrap;

    > div {
      & + div {
        margin-left: 12px;
      }
    }
  }

  @media (min-width: 1441px) {
    display: flex;
    max-width: 707px;
    margin: 0 auto;
    overflow: auto;
    white-space: nowrap;
    > div {
      & + div {
        margin-left: 12px;
      }
    }
  }
`;

export const Tag = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 6px;

  background: #f0f6ff;

  border-radius: 24px;

  > p {
    font-size: 11px;
  }

  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;

    background: transparent;
    border: 0;

    > svg {
      width: 12px;
      height: 12px;
    }

    @media (max-width: 767px) {
      > svg {
        width: 12px;
        height: 12px;
      }
    }

    @media (min-width: 1441px) {
      > svg {
        width: 16px;
        height: 16px;
      }
    }
  }

  @media (max-width: 767px) {
    > p {
      font-size: 12px;
    }
  }

  @media (min-width: 1441px) {
    > p {
      font-size: 14px;
    }
  }
`;

export const TitleLocationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    justify-content: unset;
    align-items: flex-start;
    width: unset;
    gap: 4px;
  }
`;

export const Title = styled.h6`
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: ${16 / 16}rem;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.primary.blue900};
`;
export const LocationIcon = styled.div`
  gap: 4px;
  display: flex;
  align-items: center;

  svg {
    width: ${16 / 16}rem;
    height: ${16 / 16}rem;
    color: ${({ theme }) => theme.palette.secondary.orange500};
  }
`;

export const Location = styled.p`
  font-family: "Mulish", sans-serif;
  font-size: ${14 / 16}rem;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.greyscale.grey200};
`;

export const Form = styled.form`
  display: flex;

  align-items: flex-start;
  justify-content: center;
  flex-direction: column;

  margin-top: 12px;

  > span {
    color: #ff3838;
    font-weight: bold;

    margin-bottom: 8px;
    margin-left: 8px;

    font-size: 12px;
  }
  > button {
    margin-top: 16px;
    line-height: 1.5rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: row;
    gap: 16px;
    margin-top: 0;
    flex: 1;

    > button {
      margin-top: 0;
      flex: 0;
      white-space: nowrap;
      padding-right: 30px;
      padding-left: 30px;
    }
  }
`;

export const InputContainer = styled.div<IInputContainer>`
  border: 0.5px solid
    ${({ thereIsAnError, theme }) =>
      thereIsAnError ? "#FF3838" : theme.palette.greyscale.grey200};
  border-radius: 8px;
  width: 100%;
  padding: 16px;
  gap: 16px;

  display: flex;
  align-items: center;
  position: relative;
  svg {
    width: 24px;
    height: 24px;
    color: ${({ theme }) => theme.palette.greyscale.grey200};
  }

  input {
    border: 0;
    font-size: ${16 / 16}rem;
    font-family: "Plus Jakarta Sans", sans-serif;

    &::placeholder {
      font-size: ${16 / 16}rem;
      font-weight: 600;
      opacity: 0.5;
    }
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex: 2;
  }
`;

export const AddressesOptions = styled.div`
  overflow: auto;
  overflow: overlay;
  background: #ffffff;
  position: absolute;
  z-index: 999;
  width: 100%;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;

  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15),
    0px 4px 32px 0px rgba(0, 0, 0, 0.1);

  left: 0;
  top: ${60 / 16}rem;
`;

export const AddressesOptionsContent = styled.div`
  padding: 6px 0px;
  width: 100%;
  min-height: 60px;
  max-height: 200px;
`;

export const EmptyAddressesOptions = styled.div`
  padding: 10px 20px;
  font-size: 16px;
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

export const OptionsContant = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  &:hover,
  &:focus {
    background-color: rgb(248, 249, 245);
  }

  > svg {
    margin-left: 20px;
    color: #ccc;
  }

  > button {
    border: 0;
    background: transparent;
    width: 100%;
    text-align: left;
    padding: 14px 10px;

    > p {
      font-size: 14px;
    }

    & + button {
      margin-top: 4px;
    }
  }
`;
